export const ColorTypes = [
  'primaryBlue',
  'primaryBlueDark',
  'primaryBlueDarker',
  'primaryBlueLight',
  'primaryBlueLighter',
  'primaryBlueLightest',
  'primaryCoral',
  'primaryCoralDark',
  'primaryCoralDarker',
  'primaryCoralLight',
  'primaryCoralLighter',
  'primaryCoralLightest',
  'secondaryMint',
  'secondaryMintDark',
  'secondaryMintDarker',
  'secondaryMintLight',
  'secondaryMintLighter',
  'secondaryMintLightest',
  'secondaryRose',
  'secondaryRoseDark',
  'secondaryRoseDarker',
  'secondaryRoseLight',
  'secondaryRoseLighter',
  'secondaryRoseLightest',
  'secondaryYellow',
  'secondaryYellowDark',
  'secondaryYellowDarker',
  'secondaryYellowLight',
  'secondaryYellowLighter',
  'secondaryYellowLightest',
  'tertiaryDark',
  'tertiaryLight',
  'neutral100',
  'neutral80',
  'neutral70',
  'neutral60',
  'neutral40',
  'neutral30',
  'neutral20',
  'neutral15',
  'neutral10',
  'neutral5',
  'neutral0',
  'supportSuccess',
  'supportWarning',
  'supportDanger',
  'supportInfo',
];

export const IconNameTypes = [
  'lightbulb-flash-line',
  'calendar-todo-fill',
  'check-fill',
  'check-line',
  'error-warning-fill',
  'questionnaire-fill',
  'arrow-up-s-fill',
  'arrow-down-s-fill',
  'external-link-fill',
  'arrow-right-line',
  'arrow-left-line',
  'arrow-down-line',
  'checkbox-circle-fill',
  'checkbox-circle-line',
  'mail-unread-line',
  'information-line',
  'information-fill',
  'mail-send-line',
  'mail-send-fill',
  'arrow-right-s-line',
  'pencil-line',
  'mail-line',
  'phone-line',
  'close-line',
  'close-circle-fill',
  'circle-close-line',
  'lock-line',
  'lock-fill',
  'home-line',
  'service-line',
  'file-list-2-line',
  'team-line',
  'arrow-left-circle-line',
  'arrow-down-s-line',
  'eye-line',
  'eye-off-line',
  'arrow-left-s-line',
  'folder-user-line',
  'folder-chart-line',
  'contacts-book-line',
  'logout-box-line',
  'star-fill',
  'star-line',
  'user-line',
  'survey-line',
  'flag-line',
  'restart-line',
  'add-line',
  'subtract-line',
  'pie-chart-line',
  'error-warning-line',
  'file-download-line',
  'refresh-fill',
  'question-fill',
  'time-fill',
  'indeterminate-circle-fill',
  'save-line',
  'module-1',
  'module-2-3',
  'module-2',
  'module-3',
  'module-4',
  'module-5',
  'module-6',
  'illu-wheelchair',
  'illu-circle-check',
  'illu-circle-cross',
  'illu-document-time',
  'illu-stairlift',
  'illu-user',
  'illu-heart',
  'illu-home',
  'illu-handshake',
  'illu-letter-sent',
  'illu-info',
  'illu-lamp',
  'illu-facebook',
  'illu-message',
  'illu-printer',
  'illu-sound',
  'illu-share',
  'illu-paragraph',
  'illu-heart-shield',
  'illu-play',
  'illi-document',
  'illu-saving',
  'illu-questionmark',
  'illu-feedback',
];
